"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeatOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path d="M15 20.174V6.998a1 1 0 0 0-2 0v13.176a2.999 2.999 0 1 0 3.957 3.335A2.999 2.999 0 0 0 15 20.174Z"></path><path fill-rule="evenodd" d="M19 6.998v11.107a6.996 6.996 0 0 1-.067 9.862 7.002 7.002 0 0 1-9.866 0A6.996 6.996 0 0 1 9 18.105V6.998A5 5 0 0 1 14 2a5 5 0 0 1 5 4.998Zm-9.61 17.93a5 5 0 0 0 9.22 0 4.997 4.997 0 0 0-1.04-5.434l-.57-.58V6.999a3 3 0 0 0-6 0v11.917l-.57.58a4.997 4.997 0 0 0-1.04 5.434Z" clip-rule="evenodd"></path><path d="M20.667 5.999a1 1 0 1 0 0 2H24a1 1 0 1 0 0-2h-3.333Z"></path><path d="M19.667 12.33a1 1 0 0 1 1-1H24a1 1 0 1 1 0 2h-3.333a1 1 0 0 1-1-1Z"></path><path d="M20.667 16.662a1 1 0 1 0 0 2H24a1 1 0 1 0 0-2h-3.333Z"></path><path d="M19.667 9.664a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z"></path><path d="M20.667 13.996a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"></path></g>';
var HeatOutlineSVG = function HeatOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HeatOutlineSVG = HeatOutlineSVG;
HeatOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HeatOutlineSVG);
exports.default = _default;